import { tv } from "tailwind-variants";

import { monsterrat } from "@/services/styles/fonts";

export const getSectionHeadingClass = tv({
  base: ["scroll-mt-24 text-center font-semibold lg:scroll-mt-36", monsterrat.className],
  variants: {
    size: {
      base: "text-3xl leading-[1.3] lg:text-[40px]",
      lg: "text-3xl leading-[1.2] lg:text-5xl",
      xl: "text-[40px] leading-[1.15] lg:text-[64px]",
    },
  },
  defaultVariants: {
    size: "base",
  },
});
